"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hazard = function Hazard(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M19.4319 16.7482L12.4319 4.74816C12.3879 4.67265 12.3248 4.61 12.249 4.56646C12.1732 4.52291 12.0874 4.5 12 4.5C11.9125 4.5 11.8267 4.52291 11.7509 4.56646C11.6751 4.61 11.612 4.67265 11.568 4.74816L4.56801 16.7482C4.52369 16.8241 4.5002 16.9105 4.49991 16.9984C4.49962 17.0864 4.52255 17.1729 4.56637 17.2492C4.61019 17.3254 4.67336 17.3888 4.74949 17.4328C4.82563 17.4769 4.91204 17.5001 5.00001 17.5001H19C19.088 17.5001 19.1744 17.4769 19.2505 17.4328C19.3266 17.3887 19.3898 17.3254 19.4336 17.2491C19.4774 17.1728 19.5003 17.0864 19.5 16.9984C19.4997 16.9105 19.4762 16.8241 19.4319 16.7482Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 15.625C12.3452 15.625 12.625 15.3452 12.625 15C12.625 14.6548 12.3452 14.375 12 14.375C11.6548 14.375 11.375 14.6548 11.375 15C11.375 15.3452 11.6548 15.625 12 15.625Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 8.5C11.8675 8.49992 11.7404 8.55248 11.6466 8.64613C11.5528 8.73978 11.5001 8.86684 11.5 8.99936V13.0006C11.5 13.1332 11.5527 13.2604 11.6464 13.3542C11.7402 13.448 11.8674 13.5006 12 13.5006C12.1326 13.5006 12.2598 13.448 12.3536 13.3542C12.4473 13.2604 12.5 13.1332 12.5 13.0006V8.99936C12.4999 8.86684 12.4472 8.73978 12.3534 8.64613C12.2596 8.55248 12.1325 8.49992 12 8.5Z",
    fill: props.foregroundColor
  }));
};

Hazard.defaultProps = {
  altText: "Hazard",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Hazard.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Hazard;
exports.default = _default;